export default class ReactSectionAnimation {
    static init(): void {
        const reactSection = document.querySelector<HTMLElement>('.react-section');
        if (!reactSection) return;
        const reactLogo = document.querySelector<HTMLElement>('[data-theme-img="light"][alt="IMG: React img"]');
        const reactLogoDark = document.querySelector<HTMLElement>('[data-theme-img="dark"][alt="IMG: React img"]');
        const bgCircle = document.querySelector<HTMLElement>('.circle-bg');
        const bgCircleDark = document.querySelector<HTMLElement>('.circle-bg[data-theme-img="dark"]');
        const texts = Array.from(document.querySelectorAll<HTMLElement>('.react-desktop-item'));
        const textDeco = document.querySelectorAll<HTMLElement>('.react-decoration-item');
        const textDecoDark = document.querySelectorAll<HTMLElement>('.react-decoration-item[data-theme-img="dark"]');
        const textIcons = document.querySelectorAll<HTMLElement>('.react-decoration-icon');
        const textIconsDark = document.querySelectorAll<HTMLElement>('.react-decoration-icon[data-theme-img="dark"]');

        if (
            !reactLogo ||
            !bgCircle ||
            !textDeco ||
            !textIcons ||
            !reactLogoDark ||
            !bgCircleDark ||
            !textDecoDark ||
            !textIconsDark ||
            texts.length === 0
        ) {
            return;
        }

        let animationStarted = false;

        const isDarkMode = window.getComputedStyle(reactLogoDark).display !== 'none';

        const firstPairTexts = [texts[1], texts[4]];
        const secondPairTexts = [texts[2], texts[3]];
        const thirdPairTexts = [texts[0], texts[5]];

        const firstDeco = [textDeco[1], textDeco[4]];
        const secondDeco = [textDeco[2], textDeco[3]];
        const thirdDeco = [textDeco[0], textDeco[5]];

        const firstDecoDark = [textDecoDark[1], textDecoDark[4]];
        const secondDecoDark = [textDecoDark[2], textDecoDark[3]];
        const thirdDecoDark = [textDecoDark[0], textDecoDark[5]];

        const firstIcons = [textIcons[1], textIcons[4]];
        const secondIcons = [textIcons[2], textIcons[3]];
        const thirdIcons = [textIcons[0], textIcons[5]];

        const firstIconsDark = [textIconsDark[1], textIconsDark[4]];
        const secondIconsDark = [textIconsDark[2], textIconsDark[3]];
        const thirdIconsDark = [textIconsDark[0], textIconsDark[5]];

        const animateLogo = () => {
            if (!isDarkMode) {
                reactLogo.style.transition = 'transform 0.25s ease';
                reactLogo.style.transform = 'scale(1)';
            } else {
                reactLogoDark.style.transition = 'transform 0.25s ease';
                reactLogoDark.style.transform = 'scale(1)';
            }
        };

        const animateCircle = () => {
            if (!isDarkMode) {
                bgCircle.style.transition = 'opacity 0.25s ease';
                bgCircle.style.opacity = '1';
            } else {
                bgCircleDark.style.transition = 'opacity 0.25s ease';
                bgCircleDark.style.opacity = '1';
            }
        };

        const animateFirstTexts = () => {
            firstPairTexts.forEach((text) => {
                text.style.transition = `opacity 0.25s ease`;
                text.style.opacity = '1';
            });
        };
        const animateFirstDecoration = () => {
            if (!isDarkMode) {
                firstDeco.forEach((deco) => {
                    deco.style.transition = `opacity 0.25s ease`;
                    deco.style.opacity = '1';
                });
            } else {
                firstDecoDark.forEach((deco) => {
                    deco.style.transition = `opacity 0.25s ease`;
                    deco.style.opacity = '1';
                });
            }
        };
        const animateFirstIcons = () => {
            if (!isDarkMode) {
                firstIcons.forEach((icon) => {
                    icon.style.transition = `opacity 0.25s ease`;
                    icon.style.opacity = '1';
                });
            } else {
                firstIconsDark.forEach((icon) => {
                    icon.style.transition = `opacity 0.25s ease`;
                    icon.style.opacity = '1';
                });
            }
        };
        const animateSecondTexts = () => {
            secondPairTexts.forEach((text) => {
                text.style.transition = `opacity 0.25s ease`;
                text.style.opacity = '1';
            });
        };
        const animateSecondDecoration = () => {
            if (!isDarkMode) {
                secondDeco.forEach((deco) => {
                    deco.style.transition = `opacity 0.25s ease`;
                    deco.style.opacity = '1';
                });
            } else {
                secondDecoDark.forEach((deco) => {
                    deco.style.transition = `opacity 0.25s ease`;
                    deco.style.opacity = '1';
                });
            }
        };
        const animateSecondIcons = () => {
            if (!isDarkMode) {
                secondIcons.forEach((icon) => {
                    icon.style.transition = `opacity 0.25s ease`;
                    icon.style.opacity = '1';
                });
            } else {
                secondIconsDark.forEach((icon) => {
                    icon.style.transition = `opacity 0.25s ease`;
                    icon.style.opacity = '1';
                });
            }
        };
        const animateThirdTexts = () => {
            thirdPairTexts.forEach((text) => {
                text.style.transition = `opacity 0.25s ease`;
                text.style.opacity = '1';
            });
        };
        const animateThirdDecoration = () => {
            if (!isDarkMode) {
                thirdDeco.forEach((deco) => {
                    deco.style.transition = `opacity 0.25s ease`;
                    deco.style.opacity = '1';
                });
            } else {
                thirdDecoDark.forEach((deco) => {
                    deco.style.transition = `opacity 0.25s ease`;
                    deco.style.opacity = '1';
                });
            }
        };
        const animateThirdIcons = () => {
            if (!isDarkMode) {
                thirdIcons.forEach((icon) => {
                    icon.style.transition = `opacity 0.25s ease`;
                    icon.style.opacity = '1';
                });
            } else {
                thirdIconsDark.forEach((icon) => {
                    icon.style.transition = `opacity 0.25s ease`;
                    icon.style.opacity = '1';
                });
            }
        };

        const startAnimation = () => {
            if (animationStarted) return;
            animationStarted = true;

            animateLogo();
            setTimeout(() => {
                animateCircle();
                setTimeout(() => {
                    setTimeout(() => {
                        animateFirstTexts();
                        animateFirstDecoration();
                        animateFirstIcons();
                    }, 50);
                    setTimeout(() => {
                        animateSecondTexts();
                        animateSecondDecoration();
                        animateSecondIcons();
                    }, 300);
                    setTimeout(() => {
                        animateThirdTexts();
                        animateThirdDecoration();
                        animateThirdIcons();
                    }, 550);
                }, 250);
            }, 250);
        };

        const handleScroll = () => {
            const sectionTop = reactSection.getBoundingClientRect().top;
            const sectionHeight = reactSection.offsetHeight;
            const scrollPercentage = ((window.innerHeight - sectionTop) / sectionHeight) * 100;

            if (scrollPercentage >= 50) {
                startAnimation();
                window.removeEventListener('scroll', handleScroll);
            }
        };

        const initStyles = () => {
            if (!isDarkMode) {
                reactLogo.style.transform = 'scale(0.5)';
                bgCircle.style.opacity = '0';
                textDeco.forEach((deco) => {
                    deco.style.opacity = '0';
                });
                textIcons.forEach((icon) => {
                    icon.style.opacity = '0';
                });
                texts.forEach((text) => {
                    text.style.opacity = '0';
                });
                textDecoDark.forEach((deco) => {
                    deco.style.opacity = '1';
                });
                textIconsDark.forEach((icon) => {
                    icon.style.opacity = '1';
                });
            } else {
                reactLogoDark.style.transform = 'scale(0.5)';
                bgCircleDark.style.opacity = '0';
                textDeco.forEach((deco) => {
                    deco.style.opacity = '1';
                });
                textIcons.forEach((icon) => {
                    icon.style.opacity = '1';
                });
                texts.forEach((text) => {
                    text.style.opacity = '0';
                });
                textDecoDark.forEach((deco) => {
                    deco.style.opacity = '0';
                });
                textIconsDark.forEach((icon) => {
                    icon.style.opacity = '0';
                });
            }
        };

        initStyles();
        window.addEventListener('scroll', handleScroll);
    }
}
